const STORAGE_KEY = 'yonder_age_verified';
const GATE_ATTR = 'data-age-gate';

class AgeVerification extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-age-accept]')?.addEventListener('click', () => this.#accept());
    this.querySelector('[data-age-decline]')?.addEventListener('click', () => this.#decline());
  }

  #accept() {
    localStorage.setItem(STORAGE_KEY, '1');
    document.documentElement.removeAttribute(GATE_ATTR);
    document.documentElement.style.overflow = '';
  }

  #decline() {
    const url = this.dataset.declineUrl || 'https://www.google.com';
    window.location.href = url;
  }
}

customElements.define('age-verification', AgeVerification);
